import Tool, { type ToolArgs } from '../../../tools/Tool';
import { Editor, Element, Transforms } from 'slate';
import AlignmentUtils from '../AlignmentUtils';
import { type Alignment } from '../../../types/aha-editor';
import AhaEditor from '../../../AhaEditor';
import TableUtils from '../../TablePlugin/TableUtils';

class ToolAlignment extends Tool {
  static alignment: Alignment;

  static action({ editor, alignment }: ToolArgs): void {
    if (!this.alignment) {
      throw new Error(
        'You must define a static "alignment" property in the subclass.'
      );
    }
    if (!editor?.selection) return;

    const ahaEditor = AhaEditor.getForEditor(editor);
    const tableSelection =
      ahaEditor?.controller?.state.pluginState.tableSelection;
    const tableWithinSelection = TableUtils.isTableWithinSelection(editor);

    const applyAlignment = () => {
      if (!editor?.selection) return;

      const blockEntries = Array.from(
        Editor.nodes(editor, {
          at: editor.selection,
          mode: 'lowest',
          match: (n) => Element.isElement(n) && Editor.isBlock(editor, n),
        })
      );

      for (const blockEntry of blockEntries) {
        const path = blockEntry[1];
        Transforms.setNodes(
          editor,
          { alignment: this.alignment },
          { at: path }
        );
      }
    };

    if (tableWithinSelection && tableSelection) {
      TableUtils.applyToTable(editor, tableSelection, applyAlignment);
    } else {
      applyAlignment();
    }
  }

  static isActive({ editor }: ToolArgs): boolean {
    return AlignmentUtils.currentAlignment(editor) === this.alignment;
  }
}

export default ToolAlignment;
